// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1H7qJ","title":"InfoRow_title__3hahK"};